/**
 * Better-Auth-Client fuer das Admin-UI. Deckt Login, TOTP-Bestaetigung und
 * Logout ab; alles Weitere laeuft ueber `lib/api.ts`.
 *
 * Der `onRequest`-Hook haengt das CSRF-Token an — dieselbe Regel gilt fuer die
 * Auth-Routen wie fuer `/api/v1` (Double-Submit-Cookie, siehe
 * packages/api/src/plugins/csrf.ts).
 */
import { twoFactorClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { csrfToken } from './api';
import { AUTH_BASE } from './api-paths';

export const authClient = createAuthClient({
  basePath: AUTH_BASE,
  plugins: [twoFactorClient()],
  fetchOptions: {
    credentials: 'include',
    onRequest: async (context) => {
      const method = (context.method ?? 'GET').toUpperCase();
      if (method !== 'GET') {
        context.headers.set('X-CSRF-Token', await csrfToken());
      }
      return context;
    },
  },
});
